export default "__VITE_ASSET__ClUh8PyQ__"